export enum AMOUNT_TYPE {
  FIXED = "Fixed",
  PERCENTAGE = "Percentage",
}

export enum FARE_TYPE {
  GROSS = "Gross",
  FIXED = "Fixed",
}
